export default function AcessoContextoHolder () {
  let value = undefined;

  function get() {
    return value;
  }

  function put(obj) {
    value = obj;
  }

  function getRegion() {
    return undefined;
  }

  function remove() {
    value = undefined;
  }

  return {
    get: get,
    put: put,
    remove: remove
  };
}
